import { FileArchive, FileText, X } from 'lucide-react';
import { formatFileSize } from '@/lib/upload';
import type { AttachmentItem } from '@/types/attachment';

interface FilePreviewProps {
  attachment: AttachmentItem;
  onRemove: (id: string) => void;
}

export function FilePreview({ attachment, onRemove }: FilePreviewProps) {
  const lowerName = attachment.file.name.toLowerCase();
  const isPdf = lowerName.endsWith('.pdf');
  const isZip = lowerName.endsWith('.zip');

  return (
    <div className="flex items-center gap-3 rounded-2xl border border-border/50 bg-muted/30 px-3 py-2 shadow-sm">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-background/80 text-muted-foreground">
        {isPdf ? <FileText className="h-5 w-5" /> : isZip ? <FileArchive className="h-5 w-5" /> : <FileText className="h-5 w-5" />}
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-foreground">{attachment.file.name}</p>
        <p className="text-xs text-muted-foreground">{formatFileSize(attachment.file.size)}</p>
      </div>
      <button
        type="button"
        onClick={() => onRemove(attachment.id)}
        className="rounded-full p-1 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
        aria-label={`Retirer ${attachment.file.name}`}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
